export interface Team {
  id: number;
  name: string;
  color: string;
}

interface ChipProps {
  className?: string;
  disabled?: boolean;
  'data-tag-index'?: number;
  tabIndex?: number;
  onDelete?: (event: any) => void;
  key?: number;
}

export type RenderTagProps = {
  key: number;
} & ChipProps;

export const EMPTY_STEP = { id: '', teams: [], name: '', color: '', comment: '', isCancelStep: false };

export const EDITOR_TOOLBAR_CONFIG = [
  'bold',
  'italic',
  '|',
  'bulletedList',
  'numberedList',
  '|',
  'link',
  'undo',
  'redo',
];
